import React, { useState, useEffect } from 'react';
import '../styling/containerStyles.css'
import Label from '../components/label'
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
// import { FixedSizeList } from 'react-window';
import TransactionHistory from '../transactionHistory';
import DialogBox from '../components/dialog';


interface SuccessTransactionProps{
    handleToUpdateTransactionOK:Function;
    paymentStatus:string;
    paymentMessage:string;
    transactions:any;
    transactionLoading: boolean;
    transactionCount: any;
    userType?: any;
    cmdiPhoneNumber: any;
    cmdiName: any;
}

export const SuccessTransaction: React.FC<SuccessTransactionProps> = (props: SuccessTransactionProps) =>{

    const{
    handleToUpdateTransactionOK, paymentStatus, transactions, paymentMessage, transactionLoading, transactionCount, userType,
    cmdiName, cmdiPhoneNumber
    } = props;

    const [openTransactionCount, setOpenTransactionCount] = useState(false)

    useEffect(() => {
        if(transactionCount == 0 && userType !== "ACCOUNT") {
            setOpenTransactionCount(true)
        }
    }, [transactionCount])

    const handleDialogCloseTransactionCount = () => {
        setOpenTransactionCount(false)
    }

    const handleToUpdateBankDetails = (arg: string) => {
    handleToUpdateTransactionOK(arg)
    }
    
    if(paymentStatus === 'PENDING'){
        handleToUpdateTransactionOK('PENDING')
    }
     

    return (
    <div className='suc' id="cust box">
        {paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'RESPONSE_MESSAGE' &&
        <>
        <div className='buttonAndLabel'>
            <Button className='goBack' onClick={()=> {handleToUpdateBankDetails('GoBack')}} >
                <ClearIcon /></Button>
                <Label content='Transaction Details' />
        </div>
        <br></br>
        </>
        }

        {paymentStatus==='NOT POSSIBLE' &&
        <div className='no_transaction'>
            <h1>Oops !!</h1>
            Transaction cannot be processed
            <br />
            {paymentMessage}
        </div>
        }

        {/* If amount is greater than 500 then restrict */}
        {paymentStatus==='AMOUNTINVALID' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {/* 1 user can redeem 10 coupons per day */}
        {paymentStatus==='MEMBERINVALID' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {/* Block user if user use 5 invalid coupons */}
        {paymentStatus==='BLOCKUSER' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }

        {paymentStatus==='PENDING_MESSAGE' &&
        <div className='failure_transaction'>
            {/* <h1>Transaction Failed</h1> */}
            {paymentMessage}
        </div>
        }
        {paymentStatus==='SUCCESS' &&
        <div className='success_transaction'>
            <h1>Transaction Successful</h1>
            This transaction was successful <br/>
            {transactionCount == 0 && userType !== "ACCOUNT" &&
            <DialogBox handleDialogClose={handleDialogCloseTransactionCount} open={openTransactionCount}
            message={`You can scan only 5 coupons To enjoy further benefits in CWC Dr. Fixit, Call your ${cmdiName} Now - <a href="tel:${cmdiPhoneNumber}">${cmdiPhoneNumber}</a>`} 
            imgDisp={false} />
            }
        </div>
        }
        {paymentStatus==='FAILURE' &&
        <div className='failure_transaction'>
            <h1>Transaction Failed</h1>
            {paymentMessage}
        </div>
        }
        {paymentStatus==='PENDING' &&
        <div className='pending_transaction'>
            <h1>Transaction Pending !!</h1>
            {/* This is for future use */}
            {/* Do not close this window till the transaction is complete */}
            Congratulations your request has been submitted. Money will be transferred to your Bank A/c within 72 hours.
        </div>
        }
        {paymentStatus==='RESPONSE_MESSAGE' &&
        <div className='failure_transaction validation_failure'>
            <h2>{paymentMessage}</h2>
        </div>
        }


        {
        paymentStatus !== 'NOT POSSIBLE' && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'RESPONSE_MESSAGE' &&

        <div className='success_transaction_listing'>
            <hr>
            </hr>

            <div className='briefing'>
                <div className='leftBox'>
                    <Label content="Transaction History" />
                    <div className='subtext'>Your bank account details</div>
                </div>

            </div>
            <hr>
            </hr>


            <div className='transactions history_scroll'>
                {/* {

                <FixedSizeList className="List" height={(window.innerWidth)> 340? 230 : 180}
                    itemData={transactions}
                    itemCount={transactions?.length}//transactions.length
                    itemSize={10}
                    width={(window.innerWidth) > 480?
                    window.innerWidth / 4 : window.innerWidth } >
                    {Row}
                </FixedSizeList>
                } */}
                <TransactionHistory transactions={transactions} transactionLoading={transactionLoading} />
            </div>

        </div>
        }



    </div>
    )
    }


    export default SuccessTransaction